declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const ga = {
  event(gac, gaa, gal, gav = '') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'ga.event', gac, gaa, gal, gav});
  },
  bindUserId(userId: number, parentId: number) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'userId.bind',
      userId: String(userId),
      parentId: String(parentId),
    });
  },
};
